






















import {Vue, Prop, Component, Watch} from 'vue-property-decorator'
import _ from 'lodash'
import axios from 'axios'
import { IRegisterFormData } from '@/store/modules/views/register/states'

@Component
export default class CustomMap extends Vue {

  private map = true
  private mapState: any
  private search = ''
  private suggestList = []
  private isSuggest = false
  @Prop() private address!: IRegisterFormData['address']
  @Prop() private location!: {
    lat: number,
    lon: number,
  }

  private curLocation = ''

  private handleSearchMap(event) {
    const searchMap = this.$refs.searchMap as HTMLInputElement
    if ((event || window.event).keyCode === 13) {
      this.doSearch()
      return
    }
    if (searchMap.value.length < 3) {
      this.suggestList = []
      this.isSuggest = false
      return
    }
    this.isSuggest = true
    this.mapState.Search.suggest(searchMap.value)
  }

  private doSearch() {
    this.mapState.Search.search(this.search)
  }

  private doSuggest(value) {
    this.search = value
    this.doSearch()
  }

  private watchPosition(position) {
    const location = _.pick(position, ['lat', 'lon'])
    // if (!_.isEqual(location, this.location) && this.mapState) {
    if (this.mapState) {
      this.$emit('update:location', location)
      this.mapState.location(location, true)
      if (this.mapState.Overlays.list()[0]) {
        this.mapState.Overlays.list()[0].move(position)
      } else {
        // console.log(map.Overlays)
      }
      this.onChangeMark(position)
    }
  }

  private async onChangeMark(position) {
    let address
    // if (position.address) {
    //   address = position.address
    // } else {
    address = await axios.get('https://api.longdo.com/map/services/address', {params: {
      key: process.env.VUE_APP_MAP_KEY,
      ...position,
    }}).then((res) => res.data).catch((e) => console.log(e))
    // }
    this.$emit('update:address', {
      address: this.address.address, ...address,
    })
  }

  private handleMap(map) {
    this.mapState = map
    map.Search.language('th')
    // map.Ui.DPad.visible(false)
    // map.Ui.Zoombar.visible(false)
    // map.Ui.Geolocation.visible(false)
    map.Ui.Toolbar.visible(false)
    map.Ui.LayerSelector.visible(false)
    map.Ui.Fullscreen.visible(false)
    map.Ui.Crosshair.visible(false)
    map.Ui.Scale.visible(false)
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        (position) => {
          if (!this.location.lat) {
            this.watchPosition(
              { lon: position.coords.longitude, lat: position.coords.latitude },
            )
          }
        },
      )
    } else {
      console.log('Geolocation is not supported by this browser.')
    }
    map.zoom('15', true)
    if (this.location.lat && this.location.lon) {
      map.location(this.location, true)
    }

    map.Event.bind('click', (val) => {
      this.watchPosition(map.location('POINTER'))
    })

    map.Event.bind('overlayDrop', (val) => {
      this.onChangeMark(val.location())
      // console.log('search', map.Search.search(this.search || 'สยาม'), val)
      // this.watchPosition(map.location('POINTER'), map)
    })

    map.Event.bind('suggest', (result) => {
      const searchMap = this.$refs.searchMap as HTMLInputElement
      if (result.meta.keyword !== searchMap.value) { return }
      this.suggestList = result.data
    })

    map.Event.bind('search', (result) => {
      this.isSuggest = false
      const data: any = _.head(result.data)
      if (data) {
        this.watchPosition(data)
      }
    })
    // map.Search.placeholder(
    //   document.getElementById('result')
    // )

  }

  @Watch('location')
  private onPropLocationChange(val) {
    const overlay: any = _.head(this.mapState.Overlays.list())
    const oldLocation = overlay ? overlay.location() : {}
    if (!_.isEqual(val, oldLocation)) {
      this.watchPosition(val)
    }
  }

  private mounted() {
    // console.log(this.map)
    const dialog = document.querySelector('.v-dialog .v-card__text') as HTMLElement
    if (dialog) {
      dialog.addEventListener('scroll', (ev) => {
        this.checkShowMap(ev.target as HTMLElement)
      })
      setTimeout(() => this.checkShowMap(dialog), 500)
    } else {
      document.addEventListener('scroll', (ev) => {
        this.checkShowMap(document.scrollingElement as HTMLElement)
      })
      setTimeout(() => this.checkShowMap(document.scrollingElement as HTMLElement), 500)
    }
  }

  private checkShowMap(dialog: HTMLElement) {
    const container = document.getElementById('longdoMap')
    if (!this.map && (container.offsetTop < (dialog.scrollTop + dialog.clientHeight))) {
      dialog.scrollTop = container.offsetTop + container.clientHeight
      this.map = true
    }
  }
}
